const getPersonnelNameById = (personnels, personnelId) => {
  const selectedPersonnel = personnels.filter((p) => p.id === personnelId)[0];
  return selectedPersonnel && selectedPersonnel.name;
};

export default getPersonnelNameById;
